import getFirstCharsOfName from '@/utils/getFirstCharsOfName'
import { twMerge } from 'tailwind-merge'
import {
  motion,
  TargetAndTransition,
  VariantLabels,
  Variants,
} from 'framer-motion'

interface Props {
  name?: string
  className?: string
  textClassName?: string
  animation?: {
    animate?: boolean | TargetAndTransition | VariantLabels | undefined
    variants?: Variants
  }
}

const AvatarWithName = ({
  name,
  className,
  textClassName,
  animation = undefined,
}: Props) => {
  return (
    <span
      className={twMerge(
        'inline-flex items-center justify-center bg-v8-gradient rounded-full w-10 h-10',
        className,
      )}
    >
      {animation ? (
        <motion.span
          className="w-auto h-auto"
          animate={animation.animate}
          variants={animation.variants}
        >
          <span
            className={twMerge(
              'font-medium leading-none text-white',
              textClassName,
            )}
          >
            {name ? getFirstCharsOfName(name) : ''}
          </span>
        </motion.span>
      ) : (
        <span
          className={twMerge(
            'font-medium leading-none text-white',
            textClassName,
          )}
        >
          {name ? getFirstCharsOfName(name) : ''}
        </span>
      )}
    </span>
  )
}

export default AvatarWithName
